import React from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Calendar, MapPin, ArrowRight, Briefcase } from 'lucide-react';

const NewJobsSection = ({ kycStatus, newJobs }) => {
  const navigate = useNavigate();

  return (
    <div className="wh-section">
      <div className="wh-section__header">
        <h2 className="wh-section__title">New Job Requests</h2>
        <button
          className="wh-view-all"
          onClick={() => {

            if (kycStatus !== "approved") {
              Swal.fire({
                icon: "warning",
                title: "KYC Required",
                text: "Please complete your KYC first."
              });

              navigate('/worker-kyc');
              return;
            }

            navigate('/bid-jobs?tab=new');
          }}
        >
          View All <ArrowRight size={13} />
        </button>
      </div>

      <div className="wh-jobs">
        {newJobs.map((j) => (
          <div
            key={j.id}
            className="wh-job-card"
            onClick={() => navigate('/bid-jobs')}
          >
            <div className="wh-job-card__top">
              <span className="wh-job-card__title">
                {j.jobTitle}
              </span>

              <span
                className="wh-job-card__badge"
                style={{
                  color: "#10b981",
                  background: "rgba(16,185,129,.10)"
                }}
              >
                <Briefcase size={12} />
                New
              </span>
            </div>

            <div className="wh-job-card__meta">
              <span>
                <Calendar size={13} />
                {new Date(j.deadline).toLocaleDateString()}
              </span>

              <span>
                <MapPin size={13} />
                {j.address}
              </span>
            </div>

            <div className="wh-job-card__footer">
              <span className="wh-job-card__customer">
                {j.whcustomer?.fullName || "No Customer"}
              </span>

              <span className="wh-job-card__price">
                ${j.budget}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewJobsSection;